import React, { useEffect, useState, useRef, useCallback } from "react";
import { Typography } from "@mui/material";
import Say from "src/Assets/images/say.svg";
import DownArrow from "src/Assets/images/UpButton.png";
import "./SaysActtivity.css";
import axios from "axios";
import * as Cookies from "js-cookie";
import ActivityPost from "../../ActivityPost";
import { CookieConfig } from "../../../../Utils/CookieConfig";
import CircularProgress from "@material-ui/core/CircularProgress";

import API from "../../../../network";
import SaysActivityUI from "./SaysActivityUI";
// import ConfirmationDialog from "src/Components/ConfirmationDialog";

function SaysActtivity(props) {
  const {
    activityCountRes,
    decreaseActivitySaysCount,
    onHashTagClick,
    isCountLoading,
  } = props;
  const [isListOpen, setisListOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [breadCountLength, setBreadCountLength] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const listRef = useRef(null);
  const [completeSaysListData, setCompleteSaysListData] = useState({});
  const [confModalVisible, setConfModalVisible] = useState(null);
  const [editId, setEditID] = useState(null);
  const [isAttacmentDeleted, setIsAttacmentDeleted] = useState(null);
  const [activityLoading, setActivityLoading] = useState(false);

  const toggleList = () => {
    setisListOpen(true);
  };

  const handleScroll = useCallback(() => {
    const { scrollTop, clientHeight, scrollHeight } = listRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setPageNumber((prevPageNumber) => prevPageNumber + 1);
    }
  }, []);

  const getData = async (page) => {
    try {
      setActivityLoading(true);

      const res = await API.getUserSays(breadCountLength, page);

      setListData((prevList) => [...prevList, ...res.data.hashSayList]);
      setCompleteSaysListData(res.data);
      setBreadCountLength(
        (prevBreadLength) => prevBreadLength + res.data.hashSayList.length
      );
    } catch (error) {
      console.error("Error fetching user activity says:", error);
      alert("Failed to load data. Please try again later.");
    } finally {
      setActivityLoading(false);
    }
  };

  useEffect(() => {
    if (isCountLoading) return;
    getData(pageNumber);
  }, [isCountLoading, pageNumber]);

  const decreaseSayListCount = () => {
    setCompleteSaysListData((prevData) => ({
      ...prevData,
      hashSaySize: prevData.hashSaySize - 1,
    }));
  };

  const onClose = () => {
    setConfModalVisible(null);
  };

  const confirmationForDelete = (id) => {
    setConfModalVisible({
      open: true,
      type: "warning",
      title: "Are you sure you want to delete this SAY?",
      rejectLabel: "Cancel",
      acceptLabel: "Yes",
      onReject: onClose,
      onAccept: () => deleteTag(id),
    });
  };

  const likeUnlike = (id) => {
    const newData = [...listData];
    const modifiedData = newData.find((x) => x.id === id);
    modifiedData.UserLikeStatus = "InActive";
    modifiedData.voteUp = modifiedData.voteUp - 1 + 2;
    setListData(newData);
  };

  const deleteTag = (id) => {
    let formdata = new FormData();
    formdata.append("messageID", id);
    API.deleteProfilePost(formdata)
      .then((res) => {
        const newList = [...listData];
        const index = newList.findIndex((x) => x.id === id);
        if (index > -1) {
          newList.splice(index, 1);
          setListData(newList);
          decreaseActivitySaysCount && decreaseActivitySaysCount();
        }
        setConfModalVisible(null);
      })
      .catch((err) => {});
  };

  const updateMessage = useCallback((id, message, locationName, attachment, lat, lng) => {
    const tempUrl =
      attachment instanceof File ? URL.createObjectURL(attachment) : null;
    const urlRegex =
      /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)[^\s]*)/gi;
    const extractedUrls = message ? message.match(urlRegex) || [] : [];

    setListData((prevList) =>
      prevList.map((eachItem) => {
        if (eachItem?.id === id) {
          const { newSelectedLocation, ...cleanItem } = eachItem;
          const cleanUpdatedMsg = (message || "").replace(/<[^>]+>/g, "").trim();
          const cleanDefaultMsg = (eachItem?.Message || "").replace(/<[^>]+>/g, "").trim();
          const isTextModified = cleanUpdatedMsg.length > 0 && cleanUpdatedMsg !== cleanDefaultMsg;
          const isAttachmentAdded = attachment instanceof File;
          const isContentEdited = isTextModified || isAttachmentAdded;

          return {
            ...cleanItem,
            Message: message,
            msg: message,
            url: extractedUrls.length > 0 ? extractedUrls : eachItem?.url,
            locName: locationName || "",
            msgLat: locationName ? (lat || eachItem.msgLat || "") : "",
            msgLng: locationName ? (lng || eachItem.msgLng || "") : "",
            docName:
              attachment?.name ||
              (attachment === null ? "" : eachItem.docName || ""),
            docLocation:
              tempUrl ||
              (attachment === null ? "" : eachItem.docLocation || ""),
            docTagged:
              attachment ? 1 : attachment === null ? 0 : eachItem.docTagged,
            ...(isContentEdited ? { updated_time: "1m", edited: 1 } : {}),
          };
        }
        return { ...eachItem };
      })
    );
  }, []);

  useEffect(() => {
    const handlePostUpdated = (event) => {
      const { id, message, locationName, attachment, lat, lng } = event.detail || {};
      if (id) {
        updateMessage(id, message, locationName, attachment, lat, lng);
      }
    };
    window.addEventListener("postUpdated", handlePostUpdated);
    return () => {
      window.removeEventListener("postUpdated", handlePostUpdated);
    };
  }, [updateMessage]);

  const updateEditPostId = (id) => {
    setEditID(id);
  };

  const updateNewSelectedLocation = (newSelectedLoc) => {
    setListData((prevList) =>
      prevList.map((x) =>
        x.id === editId ? { ...x, newSelectedLocation: newSelectedLoc } : x
      )
    );
  };

  const removeNewSelectedLocationKey = () => {
    setListData((prevList) =>
      prevList.map((item) => {
        const { newSelectedLocation, ...rest } = item;
        return rest;
      })
    );
  };

  const handleDeleteAttachementDoc = async (id) => {
    try {
      const response = await API.deleteAttachment(id);

      if (response?.data?.status === "success") {
        alert("Attachment deleted successfully!");

        // Update UI immediately without mutating state
        setListData((prevData) =>
          prevData.map((item) =>
            item.id === id
              ? { ...item, docName: null, docLocation: null, docTagged: 0 }
              : item
          )
        );
        setIsAttacmentDeleted(response?.data?.status);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete attachment.");
    }
  };

  return (
    <>
      {!isListOpen && (
        <div className="SaysActivity" onClick={toggleList}>
          <div className="usable-container">
            <img src={Say} alt="Ask-icon" className="askicon" />
            <Typography className="ask">SAY</Typography>
          </div>
          <div className="usable-container">
            <span className="number">{activityCountRes.allsayscount}</span>
            <img src={DownArrow} alt="DownArrow" className="DownArrow" />
          </div>
        </div>
      )}

      {isListOpen && (
        <div className="AskActivity_active">
          <div
            className="color-combination"
            onClick={() => setisListOpen(false)}
          >
            <div className="usable-container">
              <img src={Say} alt="Ask-icon" className="askicon" />
              <Typography className="ask">SAY</Typography>
            </div>
            <div className="usable-container">
              <span className="number">
                {activityCountRes.allsayscount}
              </span>
              <img src={DownArrow} alt="DownArrow" className="DownArrow" />
            </div>
          </div>
          <div
            ref={listRef}
            onScroll={handleScroll}
            role="list"
            className="posts"
          >
            {listData && listData.length !== 0 ? (
              // <ActivityPost
              //   listData={listData}
              //   updateMessage={updateMessage}
              //   delete={deleteTag}
              //   likeUnlike={likeUnlike}
              // />
              <SaysActivityUI
                listData={listData}
                updateMessage={updateMessage}
                delete={confirmationForDelete}
                likeUnlike={likeUnlike}
                onHashTagClick={onHashTagClick}
                onDelete={deleteTag}
                updateEditPostId={updateEditPostId}
                updateNewSelectedLocation={updateNewSelectedLocation}
                removeNewSelectedLocationKey={removeNewSelectedLocationKey}
                postType={"SAY"}
                filterType="activitySay"
                handleDeleteAttachementDoc={handleDeleteAttachementDoc}
                isAttacmentDeleted={isAttacmentDeleted}
                setIsAttacmentDeleted={setIsAttacmentDeleted}
              />
            ) : (
              <div className="no-data-container">
                {activityLoading ? (
                  <CircularProgress size={25} />
                ) : (
                  <p>No Activity Says found</p>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      {/* {confModalVisible?.open && <ConfirmationDialog {...confModalVisible} />} */}
    </>
  );
}

export default SaysActtivity;
